import HttpRequest from './HttpRequest';
import generateEndpoint from '../utils/generateEndpoint';

export default class CouponService extends HttpRequest {
  static endpoint = 'coupons';

  static async getAll() {
    this.endpoint = generateEndpoint('coupons');
    const response = await this.get();
    return response;
  }

  static async getById(id) {
    this.endpoint = 'coupons';
    const response = await this.get(id);
    return response;
  }

  static async create(data) {
    this.endpoint = 'coupons';
    const response = await this.post(data);
    return response;
  }

  static async remove(id) {
    this.endpoint = 'coupons';
    const response = await this.delete(id);
    return response;
  }

  static async update(id, data) {
    this.endpoint = 'coupons';
    const response = await this.put(id, data);
    return response;
  }
}
